import { render } from "./MainAgreementContent.vue?vue&type=template&id=ad74aca6&scoped=true"
import script from "./MainAgreementContent.vue?vue&type=script&lang=js"
export * from "./MainAgreementContent.vue?vue&type=script&lang=js"

import "./MainAgreementContent.vue?vue&type=style&index=0&id=ad74aca6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad74aca6"]])

export default __exports__